// 对后端过来的数据进行处理
function prodata(jsonObj, capSma) {
  // const jsonObj = { A_Aa: '123', B_Bb: null }
  if (jsonObj instanceof Object) {
    for (var key in jsonObj) {
      if (jsonObj[key] == null) {
        jsonObj[key] = ''
      }
      if (capSma) {
        jsonObj[transformStr3(key.toLowerCase())] = jsonObj[key]
        delete jsonObj[key]
      }
    }
  }
  return jsonObj
}

function transformStr3(str) {
  var re = /_(\w)/g
  return str.replace(re, function($0, $1) {
    return $1.toUpperCase()
  })
}

// 清空对象

module.exports = {
  prodata
}
